<template>
  <div class="media-section shadow-box" data-test="examination-media-table">
    <h6 class="section-title">Media</h6>
    <div class="table-responsive">
      <table class="table table-sm align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th style="width: 36px"></th>
            <th style="width: 36px">#</th>
            <th>Label</th>
            <th>Filename</th>
            <th>MIME</th>
            <th>Size</th>
            <th>Status</th>
            <th>Progress</th>
            <th>Latest upload</th>
            <th>Completed</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(m, idx) in media" :key="m.id">
            <ExaminationMediaRow
              :medium="m"
              :index="idx"
              :expanded="!!expanded[m.id]"
              @toggle="$emit('toggle', m.id)"
            />
            <tr v-if="expanded[m.id]">
              <td></td>
              <td colspan="10" class="bg-light">
                <ExaminationPartsTable :parts="m.parts || []" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ExaminationMediaRow from "./ExaminationMediaRow.vue";
import ExaminationPartsTable from "./ExaminationPartsTable.vue";

export default {
  name: "ExaminationMediaTable",
  components: {
    ExaminationMediaRow: ExaminationMediaRow,
    ExaminationPartsTable: ExaminationPartsTable,
  },
  props: {
    media: { type: Array, default: () => [] },
    expanded: { type: Object, default: () => ({}) },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
  color: #212529;
}
</style>
